import { init } from '../carousel-init';
import type JQueryStatic from 'jquery';

const $: JQueryStatic = (window as Window & typeof globalThis & {jQuery: JQueryStatic}).jQuery;

$(() => {
  document.querySelectorAll('.carousel-component').forEach(init);
});
